import { NavLink } from 'react-router-dom';
import { Building2, FileSearch, Home, LogOut, Mail, Moon, PanelLeftClose, PanelLeftOpen, Rocket, Scale, ShieldAlert, Sun, Users } from 'lucide-react';
import { Button } from './ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { allowedPathsForRole, isDisputeOpsRole } from '../config/access';

const NAV_ITEMS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/campaigns', label: 'Campaigns', icon: Mail },
  { to: '/ems', label: 'EMS', icon: ShieldAlert },
  { to: '/onboarding', label: 'Onboarding', icon: Rocket },
  { to: '/clients', label: 'Clients', icon: Building2 },
  { to: '/internal-users', label: 'Internal Users', icon: Users, adminOnly: true },
  { to: '/dispute-console', label: 'Dispute Console', icon: Scale, kamOrAdminOnly: true },
  { to: '/dn-visibility', label: 'DN Visibility', icon: FileSearch },
];

export default function Sidebar({ collapsed, onToggle, canToggle = true }) {
  const { resolvedTheme, toggleTheme } = useTheme();
  const { currentUser, logout } = useAuth();
  const ThemeIcon = resolvedTheme === 'dark' ? Sun : Moon;
  const allowedPaths = allowedPathsForRole(currentUser?.role);
  const navItems = NAV_ITEMS.filter(item => {
    // Dispute-ops gating applies to every role, restricted or not.
    if (item.kamOrAdminOnly && !isDisputeOpsRole(currentUser?.role)) return false;
    if (allowedPaths) return allowedPaths.includes(item.to);
    return !item.adminOnly || currentUser?.role === 'ADMIN';
  });
  return <aside className={`shell-rail ${collapsed ? 'collapsed' : ''}`} aria-label="Dashboards">
    <div className="rail-brand"><span className="brand-mark">A</span>{!collapsed && <div className="rail-brand-text"><span className="brand-text">ARPFlow</span><span className="brand-sub">Internal dashboard</span></div>}</div>
    <nav className="rail-nav">{navItems.map(item => {
      const Icon = item.icon;
      return <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => `rail-item ${isActive ? 'active' : ''}`} title={item.label}>
        <Icon className="rail-icon" aria-hidden="true" />{!collapsed && <span className="rail-label">{item.label}</span>}
      </NavLink>;
    })}</nav>
    <TooltipProvider><Tooltip><TooltipTrigger asChild><Button variant="ghost" size="sm" className="theme-toggle" onClick={toggleTheme} aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} mode`}>
      <ThemeIcon size={17} />{!collapsed && <span>{resolvedTheme === 'dark' ? 'Light mode' : 'Dark mode'}</span>}
    </Button></TooltipTrigger><TooltipContent side="right">Switch to {resolvedTheme === 'dark' ? 'light' : 'dark'} mode</TooltipContent></Tooltip></TooltipProvider>
    {currentUser && <TooltipProvider><Tooltip><TooltipTrigger asChild><Button variant="ghost" size="sm" className="theme-toggle" onClick={logout} aria-label={`Log out (${currentUser.name})`}>
      <LogOut size={17} />{!collapsed && <span>{currentUser.name}</span>}
    </Button></TooltipTrigger><TooltipContent side="right">Signed in as {currentUser.name} · Log out</TooltipContent></Tooltip></TooltipProvider>}
    {canToggle && <Button variant="ghost" size="sm" className="rail-toggle" onClick={onToggle} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
      {collapsed ? <PanelLeftOpen size={17} /> : <><PanelLeftClose size={17} /><span>Collapse</span></>}
    </Button>}
  </aside>;
}
